import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import AddCreateAccount from './AddCreateAccount';
import NtxTable from '@components/DataTable/NtxTable';
import useGetRevaluationList from '@hooks/FixedAssets/useGetRevaluationList';

const ListTransactions = () => {
  const [showModal, setShowModal] = useState(false);
  const { t, i18n } = useTranslation();

  const { RevaluationList: data, loading, error } = useGetRevaluationList();

  //____________________________
  const [selectedTransactions, setSelectedTransactions] = useState<string[] | any>([]);
  const handleCheckboxChange = (row: any) => {
    setSelectedTransactions((prevSelectedRows: any) => {
      const isSelected = prevSelectedRows?.some((item: any) => item.id === row.id);

      if (isSelected) {
        return prevSelectedRows?.filter((item: any) => item.id !== row.id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };

  const handleOpenAddCreateAccount = () => {
    if (selectedTransactions?.length > 0) {
      setShowModal(true);
    }
  };

  const columns = [
    { title: '', key: 'checkBox', className: 'text-center' },
    { title: t('Number'), key: 'num' },
    { title: t('نوع العمليـة'), key: 'type' },
    { title: t('Date'), key: 'date' },
    { title: t('الإدارة'), key: 'org' },
    { title: t('الفئة'), key: 'category' },
    { title: t('Status'), key: 'status' }
  ];

  // const tableData = InvReceiveList?.filter((f) => !f.postedFlag).map((item) => {
  const tableData = data?.map((item: any) => {
    // let rowClass;

    const postedFlagBadge = item.postFlag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i> {/* أيقونة للترحيل */}
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i> {/* أيقونة لعدم الترحيل */}
        {t('NotPosted')}
      </span>
    );

    return {
      checkBox: (
        <div className='form-check'>
          <input
            type='checkbox'
            className='form-check-input'
            id={`checkbox-${item.id}`}
            checked={selectedTransactions?.some((row: any) => row.id === item.id)}
            onChange={() => handleCheckboxChange(item)}
          />
        </div>
      ),

      org: i18n.language === 'ar' ? item.organizationName2 : item.organizationName,
      num: item.code,
      date: item.transactionDate?.split('T')[0],
      type: i18n.language === 'ar' ? item.transTypeName2 : item.transTypeName,

      category: i18n.language === 'ar' ? item.categoryName2 : item.categoryName,
      status: postedFlagBadge
    };
  });

  //____________________________
  const BcrumbList = [
    {
      name: 'Home',
      link: '/ASSETS/HomePage'
    },

    {
      name: 'ترحيــل عمليـات الأصـول',
      link: null
    }
  ];

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName='ترحيــل عمليـات الأصـول' />

        <div className='ms-auto'>
          <button
            type='button'
            className='btn me-1 btn-theme '
            onClick={handleOpenAddCreateAccount}
          >
            <i className='fa fa-share-square fa-fw me-1'></i>
            {t('Post')}
          </button>
        </div>
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className=' p-2'>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={10}
                theadClass=''
                tableClass='table text-nowrap table-hover '
                enableSearch={true}
                showRecordsSelector
              />
            </div>
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        bodyClassName='p-0'
        size='xl'
        showHeader={false}
      >
        <Card>
          <CardBody>
            {selectedTransactions?.length > 0 && (
              <AddCreateAccount
                selectedTransactions={selectedTransactions}
                onclose={() => setShowModal(false)}
              />
            )}
          </CardBody>
        </Card>
      </NeatixModal>
    </div>
  );
};

export default ListTransactions;
